import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a421643"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "系统内名称:", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "工商注册名称：", -1))
const _hoisted_3 = { class: "HmBusRegisterNames" }

import {
  ref,
  onMounted,
  withDefaults,
  watch,
  computed,
} from "vue";
import { checkNameDetail } from "@/api/process_company";


export default /*#__PURE__*/_defineComponent({
  props: {
    folwId: { default: 0 },
    detail: { default: () => {
      return {
        SystemNames: [],
        HmBusRegisterNames: [],
      };
    } }
  },
  setup(__props: any) {

const props = __props as { folwId: number, detail: {
      SystemNames: string[];
      HmBusRegisterNames: string[];
    } }



return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createBlock(_component_a_row, { class: "margin-bottom" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, { span: 2 }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_a_col, { span: 4 }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.detail.SystemNames, (item, index) => {
              return (_openBlock(), _createElementBlock("p", {
                key: index,
                style: {"margin-bottom":"12px"}
              }, _toDisplayString(item), 1))
            }), 128))
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_a_col, {
        span: 2.5,
        offset: "1"
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["span"]),
      _createVNode(_component_a_col, { span: 8 }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.detail.HmBusRegisterNames, (item, index) => {
              return (_openBlock(), _createElementBlock("p", {
                key: index,
                style: {"margin-bottom":"12px"}
              }, _toDisplayString(item), 1))
            }), 128))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})